import React, { FC } from 'react'
import { Button, Card, Form, Modal } from 'react-bootstrap'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import IFrame from '../../ApplicantDashboard/IFrame'
import User from '../../../types/User'
import { getDomainName } from '../../../utils/envVariables'
import ActionData from '../../../types/ActionData'
import { CircularProgress } from '@material-ui/core'
import { mainColors } from '../../../assets/colors'

interface Props {
  show: boolean;
  user: User;
  height: number;
  width: number;
  item: any;
  error: boolean;
  readOnly: boolean;
  updateApplicationItem: ActionData;
  submittingAgreement: boolean;
  onSubmit: () => void;
  onClose: () => void;
}

const ProviderAgreementModal: FC<Props> = ({ show, user, height, width, item, updateApplicationItem, submittingAgreement, error, readOnly, onClose, onSubmit }: Props) => {
  const name = `${user.first_name} ${user.last_name}`
  const iframeUrl = item
    ? !item.signed
      ? `${getDomainName()}/docusign?providerApplicationItemId=${item.providerApplicationItemId}&name=${encodeURIComponent(name)}&email=${encodeURIComponent(user.email)}`
      : `${getDomainName()}/docusign-doc?envelopeId=${encodeURIComponent(item.docusignEnvelopeId)}&name=${encodeURIComponent(name)}&email=${encodeURIComponent(user.email)}`
    : ''
  const loadingIcon = updateApplicationItem.loading ? <CircularProgress size={70} />
    : updateApplicationItem.error !== false
      ? <FontAwesomeIcon icon={['fas', 'exclamation-circle']} color={mainColors.loadingBlue} className='modal-success-icon' />
      : null
  const modalText = updateApplicationItem.error !== false ? 'The data could not be saved.' : ''
  return (
    <Modal size='xl' backdrop='static' show={show} onHide={onClose}>
      <Modal.Header closeButton id='modal-header'>
        <FontAwesomeIcon icon={['fas', 'file-alt']} size='lg' className='modal-header-icon' />
        <Modal.Title id='modal-header-title'>Provider Agreement Form</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {
          submittingAgreement ? (
            updateApplicationItem.loading || updateApplicationItem.error !== false ? (
              <div className='modal-loading-container'>
                {loadingIcon}
                <span className='modal-loading-text' style={updateApplicationItem.error !== false ? { width: '100%' } : {}}>
                  {modalText}
                </span>
              </div>
            ) : updateApplicationItem.success ? (
              <div>
                <div className='modal-success-container'>
                  <FontAwesomeIcon icon={['far', 'check-circle']} color={mainColors.successGreen} className='modal-success-icon' />
                  <span className='modal-loading-text'>Success!</span>
                  <span className='modal-success-text'>You have submitted your signature.</span>
                </div>
              </div>
            ) : null
          ) : (
            <>
              <Card style={{ background: '#f7f7f7' }}>
                <Card.Body>
                  <Card.Text>
                    All Managed Care Organization contracted providers must complete the provider enrollment agreement in order to receive payment for services provided to individuals enrolled in the Family Care program.
                  </Card.Text>
                  <Card.Text>
                    Completion of the form is required under Federal Law by the Centers for Medicare & Medicaid Services, Department of Health and Human Services.
                  </Card.Text>
                </Card.Body>
              </Card>
              <Card style={{ background: '#f7f7f7', marginTop: 15 }}>
                <Card.Body>
                  <Card.Title>DocuSign</Card.Title>
                  <IFrame
                    url={iframeUrl}
                    width={width}
                    height={height}
                    error={error}
                  />
                  {
                    error && (
                      <Form.Text className='form-error'>
                        Please sign the Provider Agreement Form before submitting.
                      </Form.Text>
                    )
                  }
                </Card.Body>
              </Card>
              <div style={{ display: 'flex', marginTop: 15, justifyContent: 'center' }}>
                <Button
                  variant='secondary'
                  className='mr-2 custom-button'
                  onClick={onClose}
                >
                  Cancel
                </Button>
                {
                  !readOnly && (item && !item.status.includes('SUBMITTED')) && (
                    <Button
                      variant='info'
                      className='custom-button'
                      type='submit'
                      onClick={onSubmit}
                    >
                      Submit
                    </Button>
                  )
                }
              </div>
            </>
          )
        }
      </Modal.Body>
    </Modal>
  )
}

export default ProviderAgreementModal